import styled from "styled-components";
import { SPACING, ANIMATION } from "../../../utils/constants";
import { BaseButton } from "../../Button";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.md + SPACING.xxs}px;
  width: 100%;

  @media (max-width: 767px) {
    padding: ${SPACING.sm + SPACING.xs}px 0;
  }
`;

export const InfoBox = styled.div`
  text-align: center;
  padding: ${SPACING.sm + SPACING.xs}px ${SPACING.md}px;
  background: var(--color-info-box-background);
  border: 1px solid var(--color-info-box-border);
  border-radius: 8px;
  margin: 0 auto ${SPACING.md}px;
  max-width: 600px;
  color: var(--color-info-box-text) !important;
  font-size: var(--text-base);
  line-height: 1.6;
  letter-spacing: 0.015em;

  /* Enhanced contrast for dark theme */
  [data-theme="dark"] & {
    background: rgba(96, 165, 250, 0.15);
    border-color: rgba(96, 165, 250, 0.35);
    box-shadow: 0 2px 8px rgba(96, 165, 250, 0.1);
  }
`;

export const OtherDetailsWrapper = styled.div`
  margin-top: ${SPACING.md}px;
  padding: ${SPACING.sm + SPACING.xs}px;
  background: var(--color-background-2);
  border-radius: 8px;
  border: 1px solid var(--color-border);
`;

export const OtherDetailsButton = styled(BaseButton)`
  background: none;
  border: none;
  color: var(--color-primary);
  font-size: var(--text-base);
  font-weight: 600;
  cursor: pointer;
  padding: ${SPACING.xs}px 0;
  display: flex;
  align-items: center;
  gap: ${SPACING.sm}px;
  font-family: inherit;
  transition: opacity ${ANIMATION.duration.normal} ${ANIMATION.easing.easeOut};

  &:hover {
    opacity: 0.8;
  }
`;

export const OtherDetailsList = styled.div`
  margin-top: ${SPACING.sm + SPACING.xs}px;
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm}px;
`;

export const OtherDetailItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACING.sm}px ${SPACING.sm + SPACING.xs}px;
  background: var(--color-card-background);
  border-radius: 6px;
  font-size: var(--text-base);
  letter-spacing: 0.015em;
  line-height: 1.5;
  transition: ${ANIMATION.transitions.all};

  &:hover {
    background: var(--hover-background);
    transform: translateX(4px);
  }

  /* Enhanced contrast for dark theme */
  [data-theme="dark"] & {
    font-weight: 500;
  }
`;
